import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-card-general-result',
  templateUrl: './card-general-result.component.html',
})
export class CardGeneralResultComponent implements OnInit {
  @Input() image = []
  @Input() title: string
  @Input() type: string
  @Input() titleSize: number
  @Input() description: string
  @Input() descriptionSize: number
  @Input() classDescription: string
  @Input() classTitle: string
  @Input() classImage: string
  @Input() medias = [{ style: 'large', media: '(min-width:421px)' }]
  @Input() path: string
  @Output() redirectPage = new EventEmitter()
  arraryTypesLabels = [
    { label: 'PROGRAMA', identifier: 'programs' },
    { label: 'EVENTO', identifier: 'event' },
    { label: 'NOTICIA', identifier: 'news' },
    { label: 'BLOG', identifier: 'blog' },
  ]
  constructor() {}

  ngOnInit() {
    this.getLabelTypes(this.type)
  }

  getLabelTypes(type) {
    let labelType = ''
    this.arraryTypesLabels.filter((item) => {
      if (item.identifier === this.type) {
        labelType = item.label
      }
    })
    this.type = labelType
  }
}
